export const ProvisionTypeEnum = {
  BOTH: 0,
  CEP_PROVISION_2: 1,
  TRADITIONAL: 2,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ProvisionTypeEnum.js